import React from "react";
import {withRouter} from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/icons
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import PreLoginHeader from "components/Header/PreLoginHeader.jsx";

import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

import axios from "axios";
import { getApiHeaders, handleApiResponse } from "../../../assets/helpers/apiHelper";
import { lineSplitToObject } from "../../../assets/helpers/displayHelper";
import { convertToDisplayDate } from "../../../assets/helpers/dataHelper";
import { API_ROOT, SUPPORT_EMAIL } from 'api-config';
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";

import logo from "assets/img/cirrusLogoSmall.png";
import { getUserGroups } from "../../../assets/helpers/utilityHelper";
var userGroups = getUserGroups()
const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  ...regularFormsStyle,
  ...customSelectStyle
};

class Agreement extends React.Component {

  constructor(props) {
    super(props);
    var signOnBehalfOfChildMember = false
    var signForUserId = ''
    var asPopupWindow = false
    var signAsCountersign = false
    var showSignedAgreement = false
    if (props.signOnBehalfOfChildMember) {
      signOnBehalfOfChildMember = props.signOnBehalfOfChildMember
    }
    if (props.signForUserId) {
      signForUserId = props.signForUserId
    }
    if (props.asPopupWindow) {
      asPopupWindow = props.asPopupWindow
    }
    if (props.signAsCountersign) {
      signAsCountersign = props.signAsCountersign
    }
    if (props.showSignedAgreement) {
      showSignedAgreement = props.showSignedAgreement
    }

    this.state = {
      agree: 0,
      agreementText: [{'line': 'loading...'}],
      agreementLabel: '',
      checkboxDisabled: true,
      fullAgreementViewed: 0,
      signText: 'I agree to the terms and conditions. (You need to view the full agreement by scrolling to the bottom before signing.)',
      headerText: 'Please read and agree to the agreement.',
      subheaderText: 'You can agree below after you have viewed the full agreement by scrolling to the bottom.',
      showSignButton: false,
      postSignUpProcess: false,
      fileName: '',
      showSignCheckbox: true,
      standaloneView: false,
      showLogo: false,
      signOnBehalfOfChildMember: signOnBehalfOfChildMember,
      showPreLoginHeader: false,
      signForUserId: signForUserId,
      asPopupWindow: asPopupWindow,
      doComponentUpdate: false,
      agreementType: '',
      addressState: '',
      signAsCountersign: signAsCountersign,
      showSignedAgreement: showSignedAgreement,
      providerId: ''
    };
  }

  sendState() {
    return this.state;
  }

  isValidated() {
    if (
      this.state.agree === 1
    ) {
      return true;
    }
    return false;
  }

  handleToggle() {
    var newAgree = '';
    if (this.state.agree === 1) {
      newAgree = 0;
    } else {
      newAgree = 1;
    }
    this.setState({
      agree: newAgree
    });
    if (this.props.handleCheckbox) {
      this.props.handleCheckbox(newAgree, this.state.fullAgreementViewed, this.state.fileName)
    }
  }

  enableAgreementSign() {
    this.setState({
      checkboxDisabled: false,
      fullAgreementViewed: 1,
      signText: 'I agree to the terms and conditions.'
    });
  }
  componentDidMount() {
    this._isMounted = true;
    const params = new URLSearchParams(this.props.location.search);
    var agreementType = '';
    var addressState = '';
    var providerId = '';
    // only do the component update if the view is in a workflow where the user could change their address
    if (this.props.location.pathname === '/signupProvider' || userGroups.indexOf('assessment') >= 0) {
      agreementType = 'providerAgreement'
      this.setState({
        doComponentUpdate: true
      });
    } else if (this.props.location.pathname === '/signupEmployer') {
      agreementType = 'employerAgreement'
      this.setState({
        doComponentUpdate: true
      });
    } else if (this.props.location.pathname === '/signup') {
      agreementType = 'memberAgreement'
      this.setState({
        doComponentUpdate: true
      });
    } else if (this.state.showSignedAgreement) {
      this.setState({
        headerText: '',
        subheaderText: '',
        showSignButton: false,
        postSignUpProcess: true,
        showSignCheckbox: false,
        standaloneView: true
      });
      this.getSignedAgreement()
    } else if (params.get('type')) {
      // if the view is the standalone agreement - no option for any action - accept the agreement type and address state as params
      agreementType = params.get('type');
      addressState = params.get('state');
      providerId = params.get('provider');
      this.setState({
        headerText: '',
        subheaderText: '',
        showSignButton: false,
        postSignUpProcess: true,
        showSignCheckbox: false,
        standaloneView: true
      });
    } else if (this.state.signOnBehalfOfChildMember) {
      agreementType = this.getAgreementType()
      this.lookupMemberAddressState(agreementType) // look up the member address if a registered member is signing the agreement
      var showSignButton = false
      if (this.state.asPopupWindow) {
        showSignButton = true
      }
      this.setState({
        headerText: '',
        subheaderText: '',
        showSignButton: showSignButton,
        postSignUpProcess: false
      });
    } else {
      agreementType = this.getAgreementType()
      this.lookupMemberAddressState(agreementType) // look up the member address if a registered member is signing the agreement
      this.setState({
        headerText: 'You need to sign the user agreement before you proceed.',
        showSignButton: true,
        postSignUpProcess: true
      });
    }

    // if an agreement type was set or returned in the get function, get agreement info
    if (agreementType) {
      this.setState({
        agreementType: agreementType //set the state of the agreement type to be used later
      })
      this.getAgreementInfo(addressState, agreementType, providerId)
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  //on update, check to see if the user has changed the address state
  componentDidUpdate(prevProps) {
    if (this.state.doComponentUpdate) {
      var updateAgreement = false
      const priorSelectedAddressState = this.getSelectedAddressState(prevProps.allStates)
      const selectedAddressState = this.getSelectedAddressState(this.props.allStates)
      if (priorSelectedAddressState !== selectedAddressState) {
        updateAgreement = true
      }
      const priorSelectedProviderId = this.getSelectedProvider(prevProps.allStates)
      const selectedProviderId = this.getSelectedProvider(this.props.allStates)
      if (priorSelectedProviderId !== selectedProviderId) {
        updateAgreement = true
      }
      if (updateAgreement) {
        this.getAgreementInfo(selectedAddressState, this.state.agreementType, selectedProviderId)
      }

    }
  }

  getSignedAgreement() {
    axios.get(`${API_ROOT}/agreement/?userId=` + this.state.signForUserId, { headers: getApiHeaders() })
      .then(res => this.setSignedAgreement({ responseMessage: res.data }));
  }

  setSignedAgreement(res) {
    var agreementText;
    if (res.responseMessage === 'unsigned') {
      agreementText = 'no agreement signed'
    } else {
      agreementText = res.responseMessage['agreementText']
      if (res.responseMessage['signedBy']) {
        var signedDate = new Date(res.responseMessage['signedDatetime']);
        var displaySignedDate = (signedDate.getMonth() + 1) + '/' + signedDate.getDate() + '/' + signedDate.getFullYear()
        agreementText += '\nsigned: ' + res.responseMessage['signedBy'] + ' on ' + displaySignedDate
      }
      if (res.responseMessage['countersignedBy']) {
        var countersignedDate = new Date(res.responseMessage['countersignedDatetime']);
        var displayCountersignedDate = (countersignedDate.getMonth() + 1) + '/' + countersignedDate.getDate() + '/' + countersignedDate.getFullYear()
        agreementText += '\ncountersigned: ' + res.responseMessage['countersignedBy'] + ' on ' + displayCountersignedDate
      }
    }
    this.setState({
      agreementText: lineSplitToObject(agreementText)
    });
  }

  //get the address from the object created during the signup process
  //this gets the most recently set address
  getSelectedAddressState(stateObj) {
    var selectedAddressState = ''
    if (stateObj) {
      var i;
      for (i = stateObj.length - 1; i >= 0; i--) {

        if (stateObj[i]) {
          var objectKey = Object.keys(stateObj[i])[0]
          if (objectKey === 'address') {
            selectedAddressState = stateObj[i]['address']['addressState']
            break;
          }
        }
      }
    }
    return selectedAddressState;
  }
  //get the provider from the object created during the signup process
  //this gets the most recently set provider
  getSelectedProvider(stateObj) {
    var selectedProviderId = ''
    if (stateObj) {
      var i;
      for (i = stateObj.length - 1; i >= 0; i--) {

        if (stateObj[i]) {
          var objectKey = Object.keys(stateObj[i])[0]
          if (objectKey === 'provider') {
            selectedProviderId = stateObj[i]['provider']['selectedProviderId']
            break;
          }
        }
      }
    }
    return selectedProviderId;
  }

  getAgreementType() {
    var agreementType = ''
    if (sessionStorage.getItem('userGroups')) {
      var userGroups = JSON.parse(sessionStorage.getItem('userGroups'))
      // if the user is a patient, we need to determine if they are part of an employer group before returning the agreement
      // otherwise, we can set the agreement based on the user group
      if (userGroups.indexOf('patient') >= 0 || this.state.signAsCountersign) {
        this.lookupAgreementType()
      } else if (userGroups.indexOf('organization') >= 0) {
        agreementType = 'providerAgreement'
      } else if (userGroups.indexOf('employer') >= 0) {
        agreementType = 'employerAgreement'
      }
    }
    return agreementType
  }

  lookupMemberAddressState(agreementType = '') {
    var userId = this.getUserId()
    if (userId) {
      axios.get(`${API_ROOT}/address/?userId=` + userId, { headers: getApiHeaders() })
        .then(res => this.setMemberAddressState({ responseMessage: res.data }, agreementType));
    }
  }

  //set the address state and get the new agreement, if relevant
  setMemberAddressState(res, agreementType = '') {
    var addressState = ''
    if (res.responseMessage['state']) {
      addressState = res.responseMessage['state']
    }
    if (agreementType) {
      this.lookupMemberProvider(addressState, agreementType)
    }
    this.setState({
      addressState: addressState
    })
  }

  lookupMemberProvider(addressState, agreementType) {
    var userId = this.getUserId()
    axios.get(`${API_ROOT}/provider/?isPrimary=1&userId=` + userId, { headers: getApiHeaders() })
      .then(res => this.setMemberProvider(res.data, addressState, agreementType));
  }

  setMemberProvider(res, addressState, agreementType) {
    var providerId = '';
    if (res[0]) {
      providerId = res[0].userId
    }
    this.getAgreementInfo(addressState, agreementType, providerId)

    this.setState({
      providerId: providerId
    })
  }
  lookupAgreementType() {
    // to lookup the agreement, first we need to determine if the user has a parent account
    axios.get(`${API_ROOT}/parentAccount/?userId=`+sessionStorage.getItem('userId'), {headers: getApiHeaders()})
      .then(res => this.setAgreementType({responseMessage: res.data}));
  }

  setAgreementType(res) {
    var agreementType = 'memberAgreement'
    const orgMembers = res.responseMessage
    var org;
    for (org in orgMembers) {
      // if the user is part of an employer group, set the agreement type as employee
      // otherwise, it stays the default member agreement
      if (orgMembers[org].orgType === 'E') {
        agreementType = 'employeeAgreement'
        break;
      }
    }
    this.setState({
      agreementType: agreementType
    });
    this.lookupMemberAddressState(agreementType)
  }

  getAgreementInfo(addressState = '', agreementType = '', providerId = '') {
    this.setState({
      agreementText: [{'line': 'loading...'}]
    });
    axios.get(`${API_ROOT}/userAgreement/?agreementType=`+agreementType+`&isActive=1&state=`+addressState+`&providerId=`+providerId, {headers: getApiHeaders()})
      .then(res => this.setAgreementInfo({responseMessage: res.data}));
  }

  setAgreementInfo(agreementData) {
    if (this._isMounted) {
      if (!agreementData.responseMessage.error) {
        this.setState({
          agreementText: lineSplitToObject(agreementData.responseMessage[0]['agreementText']),
          fileName: agreementData.responseMessage[0]['agreementType']
        });
        if (!this.state.postSignUpProcess && !this.state.signOnBehalfOfChildMember) {
          this.setState({
            headerText: 'Please read and agree to the ' + agreementData.responseMessage[0]['agreementLabel'] + ' agreement.'
          });
        } else if (this.state.standaloneView) {
          var subheaderText = agreementData.responseMessage[0]['agreementLabel'] + ' agreement'
          subheaderText = subheaderText.toUpperCase()
          subheaderText += ' (last updated ' + convertToDisplayDate(agreementData.responseMessage[0]['activeStartDatetime']) + ')'
          this.setState({
            showLogo: true,
            subheaderText: subheaderText
          });
        } else if (this.state.postSignUpProcess) {
          this.setState({
            showPreLoginHeader: true
          });
        }

        document.getElementById('agreementTextDisplay').addEventListener('scroll', this.trackScrolling);
      }
    }
  }

  getUserId() {
    var userId;
    if (this.state.signForUserId) {
      userId = this.state.signForUserId
    } else if (sessionStorage.getItem('userId')) {
      userId = sessionStorage.getItem('userId')
    }
    return userId
  }

  isBottom(el) {
    var divScrollBottom = (el.scrollHeight - el.clientHeight) * .97 //some browsers don't see the bottom properly, so enable when bottom is almost reached
    var scrollPos = el.scrollTop
    return divScrollBottom <= scrollPos;
  }

  trackScrolling = () => {
    const wrappedElement = document.getElementById('agreementTextDisplay');
    if (this.isBottom(wrappedElement)) {
      this.enableAgreementSign()
      document.removeEventListener('scroll', this.trackScrolling);
    }
  };

  submitSignAgreement() {
    if (this.state.agree !== 1) {
      alert('Please check the box to sign the agreement before proceeding.')
    } else {

      const agreementData = {
        agree: this.state.agree,
        fullAgreementViewed: this.state.fullAgreementViewed,
        fileName: this.state.fileName,
        addressState: this.state.addressState,
        providerId: this.state.providerId
      }

      const postData = {
        agreement: JSON.stringify(agreementData),
        userId: this.state.signForUserId
      }
      var urlPath = 'agreement'
      if (this.state.signAsCountersign) {
        urlPath = 'agreementCountersign'
      }
      axios.post(`${API_ROOT}/` + urlPath + `/`, postData, { headers: getApiHeaders() })
        .then(res => this.handleSignedAgreement(res));
    }
  }

  handleSignedAgreement(res) {
    handleApiResponse(res)
    if (res.data.message === 'success') {
      if (this.state.asPopupWindow && this.props.postSignFunction) {
        this.props.postSignFunction()
      } else {
        sessionStorage.setItem('agreementAcknowledged', 'true');
        window.location.reload();
      }
    } else {
      alert('There was an error signing the agreement. Please try again. Contact ' + SUPPORT_EMAIL + ' if this problem persists.')
    }
  }

  printAgreement = () => {
    const printableElement = document.getElementById('agreementTextDisplay').innerHTML;
    let printWindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

    printWindow.document.write(`<html><head><title>Agreement</title>`);
    printWindow.document.write('</head><body >');
    printWindow.document.write(printableElement);
    printWindow.document.write('</body></html>');

    printWindow.document.close(); // necessary for IE >= 10
    printWindow.focus(); // necessary for IE >= 10*/

    printWindow.print();
    printWindow.close();

    return true;

  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={12} style={this.state.showPreLoginHeader ? {} : { display: 'none' }} >
          <PreLoginHeader />
        </GridItem>
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>
            <img src={logo} alt="logo" style={this.state.showLogo ? {} : { display: 'none' }} />
          </h4>
          <h4 className={classes.infoText}>
            <span style={this.state.headerText ? {} : { display: 'none' }}>{this.state.headerText}</span>
          </h4>
        </GridItem>
        <GridItem xs={12} sm={12} style={this.state.subheaderText ? {} : { display: 'none' }}>
          <p className={classes.infoText}>{this.state.subheaderText}</p>
        </GridItem>

        <GridItem xs={12} sm={8}>
          <Button
            onClick={this.printAgreement}
            color="cirrusBlue"
            size="sm"
          >
            print
          </Button>
          <Card style={{margin: 0}}>
            <CardBody>
              <div id="agreementTextDisplay" style={{height: 300, overflow: 'auto'}}>
                {this.state.agreementText.map((textOfLine, key) =>
                  <p style={{fontSize: textOfLine.fontSize, color: textOfLine.fontColor, fontWeight: textOfLine.fontWeight}} key={key}>{textOfLine.line}</p>
                )}
              </div>
            </CardBody>
          </Card>

        </GridItem>

        <GridItem xs={12} sm={8}>
          <div className={classes.checkboxAndRadio} style={this.state.showSignCheckbox ? {} : { display: 'none' }}>
            <FormControlLabel
              control={
                <Checkbox
                  tabIndex={-1}
                  onClick={() => this.handleToggle()}
                  disabled={this.state.checkboxDisabled}
                  checkedIcon={<Check className={classes.checkedIcon} />}
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot
                  }}
                  id="agreementCheckbox"
                />
              }
              classes={{
                label: classes.label
              }}
              label={this.state.signText}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={8} style={this.state.showSignButton ? {} : { display: 'none' }}>
          <Button
            round
            color="cirrusBlue"
            onClick={this.submitSignAgreement.bind(this)}
            id="completeAgreementSigningButton"
          >
            complete signing
          </Button>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withRouter(withStyles(style)(Agreement));
